<!--

    Copyright © Siemens 2026

-->
@if (crumbs().length) {
    <ix-breadcrumb class="app-breadcrumb" (itemClick)="onItemClick($event)">
        @for (crumb of crumbs(); track crumb.url) {
            <ix-breadcrumb-item
                [label]="crumb.label"
                [breadcrumbKey]="crumb.url"
            ></ix-breadcrumb-item>
        }
    </ix-breadcrumb>
}
